export const SIGNUP_REQUEST_START = 'SIGNUP_REQUEST_START';
export const SIGNUP_REQUEST_SUCCESS = 'SIGNUP_REQUEST_SUCCESS';
export const SIGNUP_REQUEST_FAILURE = 'SIGNUP_REQUEST_FAILURE';

export const COMPANY_REGISTRATION_DATA_REQUEST_START = 'COMPANY_REGISTRATION_DATA_REQUEST_START';
export const COMPANY_REGISTRATION_DATA_REQUEST_SUCCESS = 'COMPANY_REGISTRATION_DATA_REQUEST_SUCCESS';
export const COMPANY_REGISTRATION_DATA_REQUEST_FAILURE = 'COMPANY_REGISTRATION_DATA_REQUEST_FAILURE';
